import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, Calculator, ChevronDown } from 'lucide-react';
import { AuthModal } from './AuthModal';
import { CalculatorModal } from './CalculatorModal';
import { GeldhausLogo } from './GeldhausLogo';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [authModal, setAuthModal] = useState<{
    isOpen: boolean;
    mode: 'signin' | 'signup';
  }>({
    isOpen: false,
    mode: 'signin'
  });
  const [calculatorOpen, setCalculatorOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.more-dropdown')) {
        setIsMoreOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  return <>
      <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-gray-100' : 'bg-white border-b border-gray-100'}`} data-id="element-829">
        <div className="container py-4" data-id="element-830">
          <div className="flex items-center justify-between" data-id="element-831">
            <div className="flex items-center gap-4" data-id="element-832">
              <a href="/" className="group" data-id="element-833">
                <GeldhausLogo size="md" variant="full" data-id="element-834" />
              </a>

              {/* Calculator Button - Prominent */}
              <button onClick={() => setCalculatorOpen(true)} className="hidden md:flex items-center gap-2 px-4 py-2 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-lg transition-all duration-200 shadow-md hover:shadow-lg" aria-label="Open loan calculator" data-id="element-835">
                <Calculator size={18} data-id="element-836" />
                Calculator
              </button>
            </div>

            {/* Desktop Navigation - Streamlined */}
            <nav className="hidden lg:flex items-center space-x-1" aria-label="Main navigation" data-id="element-837">
              <a href="/" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-838">
                Home
              </a>
              <a href="/about" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-839">
                About Us
              </a>
              <a href="/#core-products" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-840">
                Loan Products
              </a>
              <a href="/#trade-finance" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-841">
                Trade Finance
              </a>
              <a href="/#contact" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-842">
                Contact
              </a>

              {/* More Dropdown */}
              <div className="relative more-dropdown" data-id="element-843">
                <button onClick={e => {
                e.stopPropagation();
                setIsMoreOpen(!isMoreOpen);
              }} className="flex items-center gap-1 text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" aria-expanded={isMoreOpen} aria-haspopup="true" data-id="element-844">
                  More
                  <ChevronDown size={16} className={`transition-transform duration-200 ${isMoreOpen ? 'rotate-180' : ''}`} data-id="element-845" />
                </button>

                {isMoreOpen && <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-200 py-2 animate-slideUp" data-id="element-846">
                    <a href="/#asset-marketplace" className="block px-4 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-200" onClick={() => setIsMoreOpen(false)} data-id="element-847">
                      Buy Now Pay Later
                    </a>
                    <a href="/#ai-agent" className="block px-4 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-200" onClick={() => setIsMoreOpen(false)} data-id="element-848">
                      AI Assistant
                    </a>
                    <a href="/careers" className="block px-4 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-200" onClick={() => setIsMoreOpen(false)} data-id="element-849">
                      Careers
                    </a>
                    <div className="border-t border-gray-200 my-2" data-id="element-850"></div>
                    <a href="/#how-it-works" className="block px-4 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-200" onClick={() => setIsMoreOpen(false)} data-id="element-851">
                      How It Works
                    </a>
                    <a href="/#testimonials" className="block px-4 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors duration-200" onClick={() => setIsMoreOpen(false)} data-id="element-852">
                      Testimonials
                    </a>
                  </div>}
              </div>
            </nav>

            <div className="hidden lg:flex items-center gap-3" data-id="element-853">
              <button onClick={() => setAuthModal({
              isOpen: true,
              mode: 'signin'
            })} className="text-gray-700 hover:text-primary-600 font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:bg-primary-50" data-id="element-854">
                Sign In
              </button>
              <a href="/apply" className="btn-primary flex items-center gap-2" data-id="element-855">
                Apply Now
              </a>
            </div>

            {/* Mobile menu button */}
            <button className="lg:hidden rounded-lg p-2 text-gray-700 hover:bg-gray-100 focus:outline-none transition-colors duration-200" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" aria-expanded={isMenuOpen} data-id="element-856">
              {isMenuOpen ? <XIcon size={24} data-id="element-857" /> : <MenuIcon size={24} data-id="element-858" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && <div className="lg:hidden mt-4 pb-4 animate-fadeIn" data-id="element-859">
              <div className="flex flex-col space-y-2" data-id="element-860">
                <button onClick={() => {
              setCalculatorOpen(true);
              setIsMenuOpen(false);
            }} className="flex items-center gap-2 text-left px-4 py-3 bg-accent-500 hover:bg-accent-600 text-white font-semibold rounded-lg transition-all duration-200" data-id="element-861">
                  <Calculator size={18} data-id="element-862" />
                  Loan Calculator
                </button>
                <a href="/" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-863">
                  Home
                </a>
                <a href="/about" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-864">
                  About Us
                </a>
                <a href="/#core-products" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-865">
                  Loan Products
                </a>
                <a href="/#trade-finance" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-866">
                  Trade Finance
                </a>
                <a href="/#contact" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-867">
                  Contact
                </a>

                <div className="border-t border-gray-200 my-2" data-id="element-868"></div>

                <a href="/#asset-marketplace" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-869">
                  Buy Now Pay Later
                </a>
                <a href="/#ai-agent" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-870">
                  AI Assistant
                </a>
                <a href="/careers" className="text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" onClick={() => setIsMenuOpen(false)} data-id="element-871">
                  Careers
                </a>

                <div className="border-t border-gray-200 my-2" data-id="element-872"></div>

                <button onClick={() => {
              setAuthModal({
                isOpen: true,
                mode: 'signin'
              });
              setIsMenuOpen(false);
            }} className="text-left text-gray-700 hover:text-primary-600 font-medium px-4 py-3 rounded-lg hover:bg-primary-50 transition-all duration-200" data-id="element-873">
                  Sign In
                </button>
                <a href="/apply" className="btn-primary text-center" onClick={() => setIsMenuOpen(false)} data-id="element-874">
                  Apply Now
                </a>
              </div>
            </div>}
        </div>
      </header>

      <AuthModal isOpen={authModal.isOpen} onClose={() => setAuthModal({
      ...authModal,
      isOpen: false
    })} mode={authModal.mode} data-id="element-875" />

      <CalculatorModal isOpen={calculatorOpen} onClose={() => setCalculatorOpen(false)} data-id="element-876" />
    </>;
};